<template>
	<c-dialog ref="dialog" width="600" mode="slide" mask-close @close="dialogFormEditConfirm($refs.productForm, arguments)" @resolve="editHandle">
		<c-tips v-if="freeEdition">产品最多可创建{{systemConfig.free_product_count}}个</c-tips>
		
		<c-form ref="productForm" unit-width="100%">
			<c-title>基本信息</c-title>
			<c-form-item label="产品来源" required>
				<c-radio-group :options="productSourceName" name="product_source" v-model="product_source" placeholder="请选择产品来源" :clear="false" @change="sourceChangeHandle"></c-radio-group>
			</c-form-item>
			<c-form-item label="产品类型" required>
				<c-radio-group :options="productTypeName" name="product_type" v-model="product_type" placeholder="请选择产品类型" :clear="false" @change="typeChangeHandle"></c-radio-group>
			</c-form-item>
			<c-form-item label="产品编号">
				<c-input name="product_code" placeholder="请输入，忽略将自动生成"></c-input>
			</c-form-item>
			<c-form-item label="产品名称" required>
				<c-input name="product_name" maxlength="100"></c-input>
			</c-form-item>
			<c-form-item label="产品规格">
				<c-input name="product_spec"></c-input>
			</c-form-item>
			<c-form-item label="工艺路线" v-if="product_source != 2">
				<c-select name="route_id" async @search="searchRoute" :value-data="selectedRoute"></c-select>
				<template #handle>
					<c-link icon v-if="auth('b_processroute_edit')" @click="globalDialog('processRouteEdit')">创建工艺路线</c-link>
				</template>
			</c-form-item>
			
			<c-title>计量单位信息</c-title>
			<c-form-item label="主计量单位" required>
				<c-select name="unit_id" async @search="searchUnit" :value-data="selectedUnit" @change="setMainUnitName"></c-select>
				<template #handle>
					<c-link icon v-if="auth('b_unit_edit')" @click="$refs.unitEdit.open()">创建计量单位</c-link>
				</template>
				<c-link v-if="auth('b_unit_edit')" style="margin-top: 10px; display: inline-block" @click="isUnitConfig = !isUnitConfig">辅单位配置（{{isUnitConfig ? '折叠' : '展开'}}<i class="tf">{{isUnitConfig ? '\ued7f' : '\ued80'}}</i>）</c-link>
			</c-form-item>
			<c-form-item name="business_unit_list" label="业务单位配置" required v-show="isUnitConfig">
				<c-table ref="businessUnitTable" :data="businessUnitList" border :paging="false">
					<c-table-column label="业务范围" width="100" name="work_type">
						<template #default="{data}">
							<c-state dict="businessTypeDic" :value="data.business_type"></c-state>
						</template>
					</c-table-column>
					<c-table-column label="" width="20" name="dange">
						1
					</c-table-column>
					<c-table-column label="辅单位" width="120" name="aux_unit_id">
						<template #default="{data}">
							<c-select name="aux_unit_id" async :disabled="freeEdition" @search="searchUnit" :value-data="data.childrenUnit" v-model="data.aux_unit_id" @change="setChildrenUnitName($event, data)"></c-select>
						</template>
						<template v-if="freeEdition" #tip>
							<c-tooltip tip="此功能为【专业版】功能，请开通专业版后使用" align="end">
								<template><img src="@/assets/image/vip.png" alt="" style="height: 14px;"></template>
							</c-tooltip>
						</template>
					</c-table-column>
					<c-table-column label="" width="20" name="denghao">
						=
					</c-table-column>
					<c-table-column label="换算率" width="80" name="unit_count">
						<template #default="{data}">
							<c-input type="number" name="unit_count" decimal="6" :range="[0.000001,99999999]" :disabled="freeEdition || data.aux_unit_id == main_unit_id" v-model="data.unit_count" :clear="false"></c-input>
						</template>
					</c-table-column>
					<c-table-column label="主单位" width="80">
						<template #default="{data}">
							{{main_unit_name}}
						</template>
					</c-table-column>
				</c-table>
			</c-form-item>
			<c-form-item name="output_unit_list" label="报工单位配置" v-show="isUnitConfig">
				<m-operate border>
					<c-button v-lock="freeEdition" color="main" prepend-icon="tf-add" @click="$refs.processSelector.open(9)">选择工序</c-button>
				</m-operate>
				<c-table ref="outputUnitTable" :data="outputUnitList" border :paging="false">
					<c-table-column label="报工工序" width="115" name="process_name">
						<template #default="{data}">
							{{data.process_name}}
						</template>
					</c-table-column>
					<c-table-column label="" width="20" name="dange">
						1
					</c-table-column>
					<c-table-column label="辅单位" width="90" name="aux_unit_id">
						<template #default="{data}">
							<c-select name="aux_unit_id" async @search="searchUnit" :value-data="data.childrenUnit" v-model="data.aux_unit_id"></c-select>
						</template>
					</c-table-column>
					<c-table-column label="" width="20" name="denghao">
						=
					</c-table-column>
					<c-table-column label="换算率" width="70" name="unit_count">
						<template #default="{data}">
							<c-input type="number" name="unit_count" decimal="6" :range="[0.000001,99999999]" v-model="data.unit_count"></c-input>
						</template>
					</c-table-column>
					<c-table-column label="主单位" width="60">
						<template #default="{data}">
							{{main_unit_name}}
						</template>
					</c-table-column>
					<c-table-column type="button" label="操作" width="60">
						<template #default="row">
							<c-table-button color="red" @click="removeOutputUnitRow(row)">删除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</c-form-item>
			
			<!--自定义字段-->
			<custom-form ref="customForm" work-type="7" title="自定义信息"></custom-form>
			
			<c-title>其他信息</c-title>
			<c-form-item label="默认入库仓" tip="报工自动入库/工单退料/质检自动入库业务，将向此仓库增加相应产品库存；不配置，系统将使用全局默认仓库执行相关库存操作">
				<c-select name="default_in_warehouse_id" async @search="searchWarehouse"  :value-data="selectedInWarehouse"></c-select>
			</c-form-item>
			<c-form-item label="默认出库仓" tip="报工自动出库/工单领料/委外发料自动出库业务，将从此仓库扣减相应产品库存；不配置，则系统将使用全局默认仓库执行相关库存操作">
				<c-select name="default_out_warehouse_id" async @search="searchWarehouse"  :value-data="selectedOutWarehouse"></c-select>
			</c-form-item>
			<c-form-item label="最大安全库存" tip="商品库存大于该数值则报警" width="200">
				<c-input type="stepper" name="max_stock" decimal="6" :range="[0,99999999]" step="1"></c-input>
			</c-form-item>
			<c-form-item label="最小安全库存" tip="商品库存小于该数值则报警" width="200">
				<c-input type="stepper" name="min_stock" decimal="6" :range="[0,99999999]" step="1"></c-input>
			</c-form-item>
			<c-form-item label="成本单价" width="200" v-if="product_source != 3">
				<c-input type="stepper" name="product_price" decimal="6" :range="[0,99999999]" step="1"></c-input>
			</c-form-item>
		</c-form>
		
		<!--创建单位信息弹窗-->
		<unit-edit ref="unitEdit"></unit-edit>
		<!--选择工序弹窗-->
		<process-selector ref="processSelector" multiple @resolve="processSelectorHandle"></process-selector>
	</c-dialog>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import unitEdit from "@/pages/basic/dic_unit_edit.vue";
import processSelector from "@/components/service/process_selector.vue";

export default {
	name: 'productEdit',
	components: {unitEdit, processSelector},
	computed: {
		// 获取dictName选项数据
		...mapState(['productTypeName','productSourceName','systemConfig']),
		...mapGetters(['freeEdition'])
	},
	// 监听器
	watch: {
		id() {
			this.getDetail();
		}
	},
	mounted() {
		if (this.id){
			//查询产品详情
			this.getDetail();
		}
	},
	data() {
		return {
			editState:false,
			product_id:0,
			product_type:1,
			product_source:1,
			selectedUnit:[],
			selectedRoute:[],
			main_unit_id:'',
			main_unit_name:'-',
			businessUnitList:[],
			outputUnitList:[],
			businessDicList:[
				{business_type : 1},{business_type : 2},{business_type : 3}
			],
			selectedInWarehouse:[],
			selectedOutWarehouse:[],
			is_copy:false,//是否是复制商品页面
			isUnitConfig: false
		}
	},
	methods: {
		/************打开新增、编辑弹窗**************/
		async open(data,is_copy) {
			this.is_copy = is_copy || false;
			this.from_product_id = 0;
			this.editState = !this.is_copy && !!data;
			if (!this.editState && !(await this.checkDataCount('PRODUCT')).data) return;
			//自定义字段控件初始化
			this.$refs.customForm.init({
				formulaSource: {
					name: '产品信息',
					form: this.$refs.productForm
				}
			});
			this.$refs.productForm.clear();
			this.$refs.businessUnitTable.clear();
			this.businessUnitList=[];
			this.outputUnitList=[];
			this.selectedUnit = [];
			this.selectedRoute = [];
			this.selectedInWarehouse = [];
			this.selectedOutWarehouse = [];
			this.isUnitConfig = false;
			if (data) {
				this.product_id = data.id;
				//复制原产品ID
				this.from_product_id = data.id;
				this.getDetail();
			}else {
				this.product_id = 0;
				this.$refs.productForm.set({product_type:1,product_source:1});
				
				for (var i = 0; i < this.businessDicList.length; i++) {
					var businessDic = this.businessDicList[i];
					businessDic.aux_unit_id = 0;
					businessDic.unit_count = 1;
					this.businessUnitList.push(businessDic);
				}
				
				
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? (this.is_copy?'复制产品':'编辑产品') : '创建产品'
			});
		},

		/*******搜索产品详情*******************/
		getDetail() {
			this.request({
				url:'/product/detail',
				data: {
					id: this.product_id
				},
				loading: true,
				success: data => {
					data.min_stock = isNaN(data.min_stock)?null:data.min_stock;
					data.max_stock = isNaN(data.max_stock)?null:data.max_stock;
					data.product_price = isNaN(data.product_price)?null:data.product_price;
					if (this.is_copy){
						this.product_id = 0;
						data.product_code = '';
					}
					this.$refs.productForm.set(data);
					if (data.unit_id && data.unit){
						this.selectedUnit.push({
							name:data.unit,
							value:data.unit_id
						});
						this.main_unit_name = data.unit;
						this.main_unit_id = data.unit_id;
					}
					if (data.route_id && data.route_name){
						this.selectedRoute.push({
							name:data.route_name,
							value:data.route_id
						});
					}
					if (data.default_in_warehouse_id && data.default_in_warehouse_name){
						this.selectedInWarehouse.push({
							name:data.default_in_warehouse_name,
							value:data.default_in_warehouse_id
						});
					}
					if (data.default_out_warehouse_id && data.default_out_warehouse_name){
						this.selectedOutWarehouse.push({
							name:data.default_out_warehouse_name,
							value:data.default_out_warehouse_id
						});
					}
					//业务单位转化配置
					if (data.businessUnitList && data.businessUnitList.length > 0){
						this.businessUnitList = data.businessUnitList.map(item => {
							var obj = item;
							obj.childrenUnit = [{
								name:item.aux_unit||this.main_unit_name,
								value:item.aux_unit_id||this.main_unit_id
							}];
							return obj;
						});
					}
					
					//报工单位转化配置
					if (data.outputUnitList && data.outputUnitList.length > 0){
						this.outputUnitList = data.outputUnitList.map(item => {
							var obj = item;
							obj.childrenUnit = [{
								name:item.aux_unit,
								value:item.aux_unit_id
							}];
							return obj;
						});
					}else {
						this.outputUnitList = [];
					}
				}
			});
		},
		
		/**产品来源变更**/
		sourceChangeHandle(source){
			// //自产
			// if(source == 1){
			// 	this.product_type = 1;
			// //采购
			// }else if(source == 2){
			// 	this.product_type = 2;
			// //委外
			// }else if(source == 3){
			// 	this.product_type = 2;
			// }
		},
		/**产品类型变更**/
		typeChangeHandle(type){
			// //成品
			// if(type == 1){
			// 	this.product_source = 1;
			// //物料
			// }else if(type == 2){
			// 	this.product_source = 2;
			// }
		},
		
		/*******搜索产品单位信息*****************/
		searchUnit(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'DICUNIT',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},
		
		/******单位变更事件***/
		setMainUnitName(data){
			this.main_unit_name = data.name;
			this.main_unit_id = data.value;
			this.businessUnitList = this.$refs.businessUnitTable.getData().map(item => {
				item.childrenUnit =[{
					name: this.main_unit_name,
					value:this.main_unit_id
				}];
				item.unit_count = 1;
				return item;
			});
			
			this.outputUnitList = [];
		},

		setChildrenUnitName(optData, rowData) {
			if (optData.value == this.main_unit_id) {
				rowData.unit_count = 1;
			}
		},

		/*******搜索产品-工艺路线*****************/
		searchRoute(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'PROCESSROUTE_SEARCH',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},
		
		/******选择工序响应方法*********/
		processSelectorHandle(data) {
			//判断是否已存在于表格之中，已存在则不允许添加
			for (var i = 0; i < data.length; i++) {
				var newProcess = data[i];
				var existObj = this.$refs.outputUnitTable.getData().find(function (obj) {
					return obj.process_id == newProcess.id
				});

				//不存在，则添加至列表
				if (!existObj){
					newProcess.process_id = newProcess.id;
					newProcess.unit_count = 1;
					this.$refs.outputUnitTable.push(newProcess);
				}
			}
		},
		
		/*******搜索【仓库】下拉框信息*****************/
		searchWarehouse(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'WAREHOUSE',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},
		
		/******删除用料清单行数据********/
		removeOutputUnitRow(row) {
			var data = row.data;
			row.remove();
		},

		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			//业务单位转换配置列表
			var business_unit_list = this.$refs.businessUnitTable.getData();
			//报工工序单位转换配置列表
			var output_unit_list = this.$refs.outputUnitTable.getData();
			
			this.$refs.productForm.submit({
				url: this.editState ? '/product/edit' : 'product/add',
				rule: {
					product_type: '请选择产品类型',
					product_source: '请选择产品来源',
					product_name: '请输入产品名称',
					unit_id: '请选择产品单位',
					business_unit_list: data => {
						var flag = true;
						business_unit_list.forEach(item => {
							if(!item.aux_unit_id || !item.unit_count){
								flag = false;
							}
						});
						if (!flag) {
							return '请完善业务单位转换配置';
						}
						return true;
					},
					output_unit_list: data => {
						var flag = true;
						output_unit_list.forEach(item => {
							if(!item.aux_unit_id || !item.unit_count){
								flag = false;
							}
						});
						if (!flag) {
							return '请完善报工单位转换配置';
						}
						return true;
					},
					
					max_stock: data => {
						if(data.max_stock && parseInt(data.max_stock)<=0) return "最大安全库存必须大于0";
						if (data.min_stock && data.max_stock && parseInt(data.max_stock) <= parseInt(data.min_stock)) {
							return '最大安全库存必须大于最小安全库存';
						}
						return true;
					},
					...this.$refs.customForm.rule
				},
				dataFormatter: data => {
					data.id = this.product_id||0;
					data.route_id = data.route_id||null;
					data.min_stock = data.min_stock||null;
					data.max_stock = data.max_stock||null;
					data.product_price = data.product_price||null;
					data.default_in_warehouse_id = data.default_in_warehouse_id||null;
					data.default_out_warehouse_id = data.default_out_warehouse_id||null;
					if(this.is_copy){
						data.from_product_id = this.from_product_id;
					}
					//业务单位转换配置
					let aux_unit_list = business_unit_list.map(item => {
						return {
							config_type: 1,
							config_id: item.business_type,
							aux_unit_id: item.aux_unit_id,
							unit_count: item.unit_count
						}
					});
					//报工单位转换
					output_unit_list.forEach(item => {
						aux_unit_list.push({
							config_type: 2,
							config_id: item.process_id,
							aux_unit_id: item.aux_unit_id,
							unit_count: item.unit_count
						});
					});
					
					data.aux_unit_list = aux_unit_list;
					data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message:this.editState ?  '编辑产品成功':  (this.is_copy?'复制产品成功':'创建产品成功'),
					});
					//刷新页面
					this.$emit('resolve');
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>